import script from "./BarraFiltrosAtivos.vue?vue&type=script&setup=true&lang=js"
export * from "./BarraFiltrosAtivos.vue?vue&type=script&setup=true&lang=js"

import "./BarraFiltrosAtivos.vue?vue&type=style&index=0&id=555cbd66&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-555cbd66"]])

export default __exports__